export const phrases = {
  heading_settings_sort: "Sortering af medarbejderlisten",
  body_settings_sort: "Sorter medarbejderlisten efter for- eller efternavn.",
  since_o_clock: "Siden {time} clock",
  old_data_warning_my_area: "Vi kunne ikke indlæse nogen ny information. Sørg for, at du har forbindelse til internettet.",
  no_data_warning_my_area: "Sørg for, at du har forbindelse til internettet, og prøv igen.",
  no_data_available_my_area: "Der kan ikke indlæses data",
  last_update_data: "Sidst opdateret",
  something_went_wrong_absences: "Noget gik galt. Prøv venligst igen på et senere tidspunkt.",
  something_went_wrong_with_the_pin_entry: "Noget gik galt med indtastningen af PIN-koden...",
  pin_must_be_four_digits: "PIN-koden skal bestå af præcis fire cifre.",
  pins_do_not_match: "De indtastede PIN-koder stemmer ikke overens.",
  pin_is_not_numerical: "PIN-koden må kun bestå af tal.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Udstempling",
  finish_break: "Slut pause",
  finish_loading_time: "Slut indlæsningstid",
  finish_driving_time: "Slut køretid",
  finish_business_trip: "Afslutning af tjenesteperioden",
  finish_project_as_task: "Afslutte projektet",
  finish_special_one: "Slut special1",
  finish_special_two: "Slut Special2",
  you_clockout: "Du stempler dig selv ud",
  sentence_work_time: "Du er i gang. | Du arbejder lige nu.",
  sentence_break: "Du tager en pause. | Du tager en pause.",
  sentence_loading_time: "Du er i øjeblikket ved at registrere indlæsningstid. Hauruck! | Du er i øjeblikket ved at registrere indlæsningstiden. Jerk!",
  sentence_business_trip: "Tjeneste logget ind. God fornøjelse!",
  sentence_driving_time: "Du bestiller køretid. Spænd sikkerhedsselen og af sted! | Du bestiller rejsetid. Spænd sikkerhedsselen og kør!",
  sentence_special_one: "Du bestiller Special 1. | Du bestiller Special 1.",
  sentence_special_two: "Du bestiller Special 2. | Du bestiller Special 2.",
  sentence_custom_time: "Du booker | Du booker",
  you_are_booked_in_activity: "Du stempler {activity}! | Du stempler {activity}!",
  substitute_warning: "{ days } Der skal udpeges en stedfortræder ved fravær på flere dage eller mere.",
  substituted_by: "Repræsenteret af",
  name_clocked_in: "{name} stemplet",
  /************************************/
  //Signature stuff:

  signature: "Signatur",
  please_sign: "Underskriv venligst",
  signature_with_date: "Underskrift fra {date}",
  signature_with_date_with_name: "Underskrift af {date} fra {name}",
  signature_with_date_with_location: "Underskrift af {date} på {location}",
  signature_with_date_with_name_with_location: "Signatur af {date} fra {name} i {location}",
  signature_with_name: "Underskrift af {name}",
  signature_with_name_with_location: "Underskrift af {name} på {location}",
  signature_with_location: "Underskrift på {location}",
  /*************************************/

  accept_terms_and_conditions: "Ved at sende formularen accepterer du vores {agb} og vores {datenschutzerklaerung}.",
  what_is_your_name: "Hvad er dit navn?",
  your_email: "Din e-mailadresse",
  what_is_your_company_name: "Hvad er navnet på din virksomhed?",
  what_do_you_want_to_do_with_clockin: "Hvad vil du gøre med clockin?",
  almost_finished: "Næsten færdig",
  test_clockin_for_amount_period: "Prøv clockin {amountOfDaysTestPeriod} gratis i et par dage!",
  code_needed_to_connect: "Brug din kode",
  you_have_no_company_code: "Har du ikke en kode? Kontakt personen i din virksomhed.",
  connect_your_device: "Tilslut din enhed!",
  please_type_in_device_id: "Indtast venligst enhedens ID, som du finder under mobile enheder på vores websted.",
  new_at_clockin: "Ny til clockin?",
  pin_repeat: "Gentag PIN-kode",
  configure_your_pin: "Indstil din 4-cifrede PIN-kode",
  configure_your_pin_text: "Du skal bruge PIN-koden for at få adgang til dit personlige område på tabletterminalen.",
  congratulations: "Tillykke med det!",
  start_now: "Kom i gang nu",
  device_name_info: "Du kan ændre enhedsnavnet på din mobilenhed, så du kan holde styr på flere enheder. Eksempel: \"Smartphone MaxMustermann\". Navnet kan også ændres på et senere tidspunkt.",
  select_project: "Vælg projekt",
  select_time: "Vælg tid",
  create_new_account: "Opret en ny konto",
  join_my_company: "Bliv medlem af mit firma",
  join_clockin_with_qr: "Tilmeld dig med QR-kode",
  change_project: "Ændre projekt",
  my_messages: "Mine nyheder",
  my_documents: "Mine dokumenter",
  my_data_and_passwords: "Mine data og adgangskoder",
  my_account_data: "Mine data",
  change_my_password: "Ændre adgangskode",
  forgot_password: "Jeg kender ikke min adgangskode.",
  open_camera: "Åbn kameraet",
  scan_now: "Scan nu",
  sync_now: "Synkroniser nu",
  clear_logs: "Tomme logfiler",
  saveAndGoBack: "Gem og returner",
  full_day: "Hele dagen",
  activate_scanner: "Scanneren er aktiveret",
  scanner_is_inactive: 'Scanner inaktiv',
  change_project_by_scan_qr: "Scan QR-koden for det projekt, du vil skifte til.",
  scan_device_by_qr: "Scan QR-koden fra den enhed, du ønsker at bruge.",
  no_access_to_camera_please_connect_device_manually: "Kameraet kunne desværre ikke tilgås, indtast venligst enhedskoden manuelt.",
  no_access_to_camera_please_clockin_manually: "Desværre var det ikke muligt at få adgang til kameraet, så du bedes stemple ind manuelt.",
  qr_code_login: "Registrering af QR-kode",
  scan_to_login: "Scan din QR-kode for at logge ind.",
  checklist_was_saved: "Tjeklisten blev gemt",
  question_save_changes_short: "Gemme ændringer?",
  question_save_changes: "Ønsker du at gemme ændringerne?",
  question_delete_checklist_short: "Slet tjekliste?",
  question_delete_checklist: "Er du sikker på, at du vil slette tjeklisten?",
  checklist_is_sending: "Tjekliste vil blive sendt",
  checklist_sent_successfully: "Tjekliste sendt 🎉",
  checklist_could_not_be_sent: "Tjeklisten kunne ikke sendes, prøv igen senere.",
  checklist_transmission_problems_in_the_past: "Tidligere har der været overførselsproblemer med nogle filer.",
  checklist_send_with_potential_data_loss: "Vil du prøve at sende tjeklisten uden disse filer?",
  documentation_is_sending: "Projektdokumentation sendes",
  documentation_sent_successfully: "Projektdokumentation sendt med succes 🎉",
  confirm_documentation_dismissal: "Vil du virkelig kassere dokumentationen?",
  discard_unsaved_changes: "Vil du kassere dine ændringer?",
  documentation_will_be_sent_when_online: "Dokumentationen vil blive sendt, så snart du er online igen.",
  confirmation_is_sending: "Der sendes en projektbekræftelse",
  ask_for_geo_permission: "Denne app har brug for din placering, " + "men ikke har tilladelse til at gøre det.\n\n" + "Ønsker du at åbne indstillingerne?",
  all_projects: "Alle projekter",
  half_day: "Halv dag",
  start_end: "I henhold til tid",
  my_area: "Mit område",
  my_area_video_teaser_clockin_explained_by_frederik: "uret forklaret af Freddi",
  add_time: "Skab tid",
  show_times_in_confirmation: "Visningstider i bekræftelsen",
  change_time: "Tidspunkt for ændring",
  finish_project: "Fuldføre projektet",
  finish_project_date: "Færdiggør aftale",
  unfinish_project: "Genåbne projektet",
  unfinish_project_date: "Genåbne aftale",
  absence_overview: "Håndtering af fravær",
  edit_absence: "Rediger fravær",
  edited_absence: "Fravær redigeret",
  created_absence: "Anmodning om orlov oprettet med succes",
  creating_absence: "Din orlovsansøgning er nu oprettet",
  error_creating_absence: "Fejl ved oprettelse af fraværsanmodning",
  create_absence: "Oprette fravær",
  deleted_absence: "Anmodning om fravær trukket tilbage",
  new_request: "Ny ansøgning",
  your_requests: "Dine ansøgninger",
  planned_days: "Planlagte dage",
  planned_hours: "Planlagte åbningstider",
  used_days: "Anvendte dage",
  used_hours: "Brugte timer",
  free_days: "Fridage",
  free_hours: "Åbningstider for ferie",
  open_days: "Åbne dage",
  open_hours: "Åbningstider",
  withdraw_request: "Tilbagekaldelse af ansøgningen",
  change_request: "Anmodning om ændring",
  request_was_approved: "Din ansøgning blev godkendt",
  request_is_pending: "Din ansøgning er endnu ikke blevet godkendt",
  request_was_rejected: "Din ansøgning blev afvist",
  add_attachment: "Tilføj vedhæftede fil",
  message_optional: "Meddelelse (valgfrit)",
  filed_on: "Indsendt den",
  this_year: "I år",
  search_sub_projects: "Hvilket delprojekt vil du gerne arbejde på?",
  error_occurred: "Der er opstået en fejl, prøv igen senere.",
  re_record: "Slette og genoptage denne video?",
  delete_video: "Slette optagelse?",
  no_results_found: "Ingen resultater fundet",
  record_again: "Prøv",
  request_valid_email: "Indtast venligst en gyldig e-mailadresse.",
  request_valid_company_name: "Indtast venligst et gyldigt firmanavn.",
  request_valid_first_name: "Indtast venligst et gyldigt fornavn.",
  request_valid_last_name: "Indtast venligst et gyldigt efternavn.",
  total_duration_today: "Samlet tid i dag",
  show_daily_protocol: "Vis daglig logbog",
  change_profile_pic: "Ændre profilbillede",
  logout_account: "Afbryd kontoen",
  you_are_working: "Du arbejder lige nu!",
  you_are_taking_a_break: "Du har en pause!",
  activity_edited: "Aktivitet redigeret",
  activity_edited_undo: "Behandlingen er blevet annulleret med succes",
  activity_edited_missing_project: "Åh, projektet mangler stadig!",
  activity_deleted: "Aktivitet slettet",
  activity_deleted_undo: "Slettet aktivitet genoprettet",
  activity_created: "Ny aktivitet oprettet",
  activity_created_undo: "Nyoprettet aktivitet trukket tilbage",
  correct_working_hours: "Korrekte arbejdstider",
  your_changes_are_being_saved: "Dine ændringer er nu gemt.",
  manage_working_hours: "Administrer arbejdstiden",
  delete_activity: "Slet aktivitet",
  start_navigation: "Start navigation",
  no_valid_email: "Den indtastede e-mail-adresse er ikke gyldig.",
  delete_checklist: "Slet tjekliste",
  active_checklists: "Aktive tjeklister",
  scan_qr_code: "Scan QR-kode",
  switch_to_office_center: "Skift til kontorcentret",
  confirm_project_completion_short: "Fuldføre projektet",
  confirm_project_date_completion_short: "Færdiggør aftale",
  project_completed: "Projektet er afsluttet!",
  project_date_completed: "Aftalen er på plads!",
  confirm_project_uncompletion_short: "Genåbne projektet",
  confirm_project_date_uncompletion_short: "Genåbne aftale",
  project_uncompleted: "Projekt aktiveret",
  project_date_uncompleted: "Dato for aktivering",
  choose_project: "Vælg projekt",
  choose_sub_project: "Vælg underprojekt",
  choose_site: "Vælg placering",
  active_projects: "Aktive projekter",
  completed_term: "afsluttet",
  completed_projects: "Afsluttede projekter",
  end_of_work: "Hav en god aften",
  correct_time: "Korrekt tid",
  you_stamp_x: "Du stempler",
  enter_pin: "Indtast venligst PIN-kode",
  wrong_pin: "Forkert indtastning af PIN-kode",
  pin_change_required: "Du er blevet bedt om at ændre din PIN-kode",
  enter_new_pin: "Indtast ny PIN-kode",
  approve_pin: "Bekræft PIN-kode",
  no_projects_scheduled: "For {day} Ingen projekter gemmes.",
  you_clock_in_project: "Du registrerer projektets arbejdstid fremover.",
  project_scan_error: "Denne kode er ikke gyldig for noget projekt.",
  show_more_days: "Vis flere dage",
  show_more_times: "Vis flere tider",
  only_show_today: "Vis kun i dag",
  todays_total_time: "Samlet tid i dag",
  everything_synced: "Dine data er opdaterede!",
  upload_in_progress: "Dataene bliver uploadet...",
  who_are_you: "Hvem er du?",
  is_uploading_to_server: "Dine ændringer overføres til kontorcentret.",
  offline_and_data_is_stored_locally: "Dine ændringer vil snart blive overført til kontorcentret. ",
  show_more: "Vis mere",
  activity_edited_wrong_date: "Du har indtastet en forkert dato.",
  confirm_logout: "Ønsker du virkelig at afmelde dig?",
  confirm_clockout: "Er du sikker på, at du vil stemple ud for i dag?",
  gps_is_active: "GPS-data overføres",
  location_tracking_is_active: "For at aktivere GPS-sporing.",
  app_settings: "App-indstillinger",
  clock_reminder: "Frimærke - Påmindelse",
  mon_to_fri: "Standard: Mandag - fredag",
  logout: "Afbryd kontoen",
  refresh: "Opdatering",
  prompt_language_settings: "Indstil sproget for appen her.",
  prompt_clock_reminder: "Påmindelse via push-notifikation for at matche dit daglige arbejde.",
  register_company: "Registrer virksomhed",
  use_code: "Brug koden",
  our_customers: "Vores kunder",
  free_test_now: "Test nu gratis",
  tier_attendance: "Jeg registrerer kun arbejdstid og pauser.",
  tier_documentation: "Jeg vil også gerne booke arbejdstid på projekter, som jeg administrerer i clockin.",
  your_tier: "Din pakke",
  all_clockin_functions: "Alle clockin-funktioner",
  checklists_formulars: "Tjeklister og funktioner",
  projectfile_incl_chat: "Digitale projektfiler (inkl. chat)",
  photo_sketch_note: "Foto-, skitse- og notefunktion",
  digital_signature: "Digitale signaturer",
  datev_connection: "DATEV-tilslutning",
  calendar_absences: "Administrer kalender og fravær",
  individual_design: "Individuelt udseende",
  attendance_time_tracking: "Stationær tidsregistrering via tabletterminal",
  mobile_time_tracking: "Mobil tidsregistrering via smartphone-app",
  browser_time_tracking: "Browser tidsregistrering på pc'en til hjemmekontoret",
  help_use_code: "Indtast den kode, som du finder i kontorcentret under mobile enheder/medarbejdere.",
  wrong_code: "Forkert kode",
  wrong_code_text: "Koden er ikke gyldig. Prøv venligst igen med en gyldig kode",
  wrong_code_text_short: "Koden er ugyldig",
  clockin_logo: "Clockin-logo",
  invalid_qr_code: "Ugyldig QR-kode",
  invalid_qr_code_text: "Den scannede QR-kode er ikke gyldig. Scan venligst en gyldig clockin-kode.",
  code_already_connected: "Med denne kode kan du forbinde din enhed. Men du er allerede forbundet.",
  wrong_credentials: "Forkerte adgangsdata",
  wrong_credentials_text: "Den kombination af e-mail og adgangskode, du indtastede, kunne ikke findes. Tjek venligst din indtastning og prøv igen.",
  new_pin: "Indtast ny PIN-kode",
  choose_next_action: "Vælg din næste handling",
  name_of_software_package: "Navn på softwarepakken",
  select_teamleader: "Hvem stempler for holdet?",
  select_teamleader_description: "Hvis du vil fortsætte med at stemple, skal du vælge en person, som nu skal overtage maskinen.",
  clocked_in_on_this_device: "Stemplet på denne enhed",
  not_clocked_in_on_this_device: "Ikke stemplet på denne enhed",
  select_new_teamleader: "Hvem skal stemple for holdet nu?",
  switch_teamleader: "Overdragelse af enhed",
  just_me: "Jeg stempler bare ud",
  select_the_new_teamleader: "Bestem den nye teamleder",
  back_to_selection: "tilbage til udvælgelsen",
  manage_team: "Administrer teamet",
  total_time_team: "Teamets samlede tid",
  count_members_clocked_in: "{clockedin}/{members} Holdmedlemmer stemplet ind",
  whole_team: "Hele holdet",
  teammembers_still_clockedin: "Vælge, om du kun vil stemple ud for dig selv eller for alle i teamet?",
  clockout_all: "Udrydde alle",
  select_employee: "Vælg først en bruger",
  something_went_wrong: "Noget gik galt, prøv venligst igen senere.",
  new_pin_successfully_changed: "PIN-kode ændret med succes",
  enter_pin_before_clockin_prompt: "Først skal du indtaste din pinkode én ad gangen for at stemple ind.",
  enter_pin_before_clockout_prompt: "Indtast først din pinkode én ad gangen for at stemple ud.",
  delete_activity_alert_title: "Slet aktivitet",
  delete_activity_alert_msg: "Er du sikker på, at du vil slette aktiviteten?",
  delete_absence_message: "Er du sikker på, at du vil trække ansøgningen tilbage?",
  delete_absence_title: "Tilbagekaldelse af ansøgningen",
  are_you_sure: "Er du sikker?",
  request_password: "Anmod om ny adgangskode",
  password_requested: "Et link til en ny adgangskode er blevet sendt til din e-mailadresse.",
  no_email_retrieved: "Har du ikke modtaget en e-mail? Tjek venligst din spam-mappe, eller prøv igen.",
  name_of_customer: "Kundens navn",
  missing_permissions_homepage_text: "Du har ikke tilladelse til at ændre din aktivitet på denne maskine. Kontakt venligst din administrator for at få adgang.",
  no_permission_warning_my_area: "Du har ikke tilladelse til at få adgang til dette område. Kontakt venligst din administrator for at få adgang.",
  employee_clocked_in: "{name} registreret!",
  employee_clocked_out: "{name} logget af!",
  no_employee_to_qr_code_warning: "Der kunne ikke findes nogen medarbejder til denne QR-kode.",
  no_employees_registered_heading: "Der er endnu ikke blevet tildelt personale til denne enhed.",
  no_employees_registered_body: "I kontorcentret kan du i indstillingerne for den mobile enhed tildele medarbejdere, som så får lov til at registrere deres tid på denne enhed.",
  no_employee_found: "Desværre kunne vi ikke finde nogen med dette navn.",
  no_employee_assigned: "Ingen medarbejder tildelt",
  you_need_help: "Har du brug for hjælp?",
  here_you_can_get_help_to_register_employees_for_device: "Her finder du alle oplysninger om, hvordan du tildeler personale til en enhed.",
  show_time: "Skab tid",
  export_timesheet: "Eksporter timeseddel",
  select_month: "Vælg måned",
  internet_connection_required: "Det kræver en internetforbindelse.",
  select_an_activity_to_clockin_your_team: "Vælg en aktivitet at stemple i dit team.",
  confirm_uploading_sqlite_for_debugging: "Er du sikker på, at du vil uploade data i appen til Clockin-support?",
  no_tasks_available: "Ingen opgaver tilgængelige",
  click_to_add_tasks: "Klik for at tilføje opgaver",
  scan_nfc_tag: "Hold venligst dit kort op mod læseren.",
  link_nfc_tag: "Link NFC-tag",
  select_employee_for_nfc_tag: "Vælg en medarbejder for at tilknytte dette NFC-tag:",
  nfc_tag_linked_successfully: "NFC-tag med succes med {name} Knyttet.",
  nfc_linking_failed: "NFC-tag kunne ikke linkes. Prøv igen.",
  nfc_not_enabled: "NFC understøttes ikke af denne enhed eller er deaktiveret.",
  nfc_initialization_failed: "Desværre gik noget galt. Prøv igen.",
  nfc_scan_failed: "Desværre gik noget galt. Prøv igen.",
  nfc_no_tag_found: "Der blev ikke fundet noget NFC-tag.",
  nfc_tag_already_linked_to: "Dette NFC-tag er allerede tilgængeligt med {name} Knyttet.",
  nfc_scan_active: "NFC-scanning aktiv",
  nfc_linking_enabled: "NFC-tags kan nu linkes. Hold venligst NFC-tagget for at blive knyttet til NFC-læseren nu.",
  nfc_all_employees_linked: "Alle medarbejdere, der er tildelt denne enhed, er allerede blevet tilknyttet.",
  no_employee_to_nfc_warning: "Der kunne ikke findes nogen medarbejder til dette NFC-tag.",
  select_employee_to_link_nfc: "Hvem skal NFC-tagget linkes til?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Velkommen til clockin",
        clocking_time: "Banetider",
        push_notifications: "Glem ikke noget"
      },
      text: {
        clocking_time: "Clockeren er dit udgangspunkt for enhver aktivitet. Du tager dig af dit arbejde, appen laver dokumentationen.",
        push_notifications: "Tænd nu for notifikationer. Clockin minder dig om, hvis du glemmer et stempel, og sørger for, at du får alt vigtigt med det samme."
      },
      button: {
        lets_go: "Kom i gang nu"
      }
    },
    my_area: {
      heading: {
        my_area: "Mit område",
        absences: "Fravær og ansøgninger",
        settings: "Personlige indstillinger"
      },
      text: {
        my_area: "Det centrale sted, hvor du har et øjeblikkeligt overblik over dine arbejdstider og dit overarbejde. Herfra kan du administrere dine arbejdstider, få adgang til din daglige log, indsende anmodninger og se dine tider.",
        absences: "Administrer ferieansøgninger, sygedage og andet fravær. Hold altid styr på status for dine anmodninger, og indsend nye hurtigt og nemt med blot et par klik.",
        settings: "Send beskeder til virksomheden eller ændr dine personlige indstillinger, og hvis du vil ændre din adgangskode, kan du også gøre det her!"
      },
      button: {
        lets_go: "Kom i gang"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Fordi din tid tæller",
        clock_in: "Stempel i",
        switch_task: "Stempelændring",
        clock_out: "Udstempling",
        thats_it: "Det var det!"
      },
      text: {
        your_time_matters: "Med clockin hjælper vi dig med at koncentrere dig om det væsentlige. Registrer din arbejdstid med bare ét klik.",
        clock_in: "Med et enkelt klik bliver du stemplet ind direkte. Clockin gemmer automatisk dine data, så du altid har det hele ved hånden.",
        switch_task: "Har du et andet projekt, tager du en pause eller er du på vej til din næste aftale? Du skal blot omstemple dig selv til din nye aktivitet. Resten registreres automatisk.",
        clock_out: "Og med et klik er du stemplet ud.",
        thats_it: "Du har gjort det og er klar til at registrere din arbejdstid. Hvis du har brug for hjælp, skal du bare kontakte os. Alt er nemt med clockin - også at kommunikere med os."
      },
      button: {
        your_time_matters: "Vis mig, hvordan man gør",
        thats_it: "Kom i gang nu"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Fordi din tid tæller",
        clock_in: "Stempel i",
        clock_in_team: "Tjek ind-team",
        switch_task: "Stempelændring",
        change_teamleader: "Overdragelse af enhed",
        clock_out: "Udstempling",
        thats_it: "Det var det!"
      },
      text: {
        your_time_matters: "Med clockin hjælper vi dig med at koncentrere dig om det væsentlige. Registrer dit teams arbejdstid med blot ét klik.",
        clock_in: "Vælg en person, der stempler ind for teamet, og med et enkelt klik bliver du stemplet ind direkte. Clockin gemmer automatisk dine data, og du kan altid holde øje med alt.",
        clock_in_team: "Du skal blot stemple dit team direkte. Enten alle på samme tid eller bare enkelte medlemmer.",
        switch_task: "Har du et andet projekt, holder du pause eller er du på vej til din næste aftale? Du skal blot stemple din nye aktivitet. Resten bliver registreret automatisk.",
        change_teamleader: "Er du færdig med at arbejde, skal du gå, eller skal du ikke længere stemple ind for teamet? Du skal blot aflevere enheden i appen, og så går alt tilbage til det normale.",
        clock_out: "Og med et enkelt klik er du og dit team stemplet ud. Du kan selvfølgelig også til enhver tid stemple enkelte medlemmer ud.",
        thats_it: "Du har gjort det og er klar til at registrere arbejdstiden for dit team. Hvis du har brug for hjælp, skal du bare kontakte os. Alt er nemt med clockin - også at kommunikere med os."
      },
      button: {
        your_time_matters: "Vis mig, hvordan man gør",
        thats_it: "Kom i gang nu"
      }
    },
    my_area: {
      heading: {
        welcome: "Velkommen til dit område",
        my_area: "Mit område",
        create_time: "Skab tid",
        change_time: "Korrekt tid",
        absences: "Fravær og ansøgninger",
        settings: "Personlige indstillinger",
        thats_it: "Det var det!"
      },
      text: {
        welcome: "Opdag endnu flere måder at administrere din arbejdstid effektivt og nemt på. Lad os tage et kig på dit område.",
        my_area: "Det centrale sted, hvor du har et øjeblikkeligt overblik over dine arbejdstider og dit overarbejde. Herfra kan du administrere dine arbejdstider, få adgang til din daglige log, indsende anmodninger og se dine tider.",
        create_time: "Har du glemt at indtaste en tid, eller vil du gerne tilføje tider senere? Det er ikke noget problem! Tilføj manglende tider, registrer pauser og hold din arbejdstidskonto opdateret.",
        change_time: "Vil du rette dine tider? Det er ikke noget problem! Med clockin kan du nemt rette og justere forkerte tider.",
        absences: "Administrer ferieansøgninger, sygedage og andet fravær. Hold altid styr på status for dine anmodninger, og indsend nye hurtigt og nemt med blot et par klik.",
        settings: "Send beskeder til virksomheden eller ændr dine personlige indstillinger, og hvis du vil ændre din adgangskode, kan du også gøre det her!",
        thats_it: "Du har gjort det! Nu kan du nemt styre din tid, organisere fravær og koncentrere dig om det, der er vigtigt: dit arbejde. Held og lykke med din produktive tid!"
      },
      button: {
        welcome: "Vis mig, hvordan man gør",
        thats_it: "Kom i gang nu"
      }
    },
    clock: {
      clockin_now: "Lås ind nu",
      clock_your_first_time_now: "& optag din første gang"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "Tak, fordi du bruger clockin!",
      question: "Hvor sandsynligt er det, at du vil anbefale clockin til venner eller kolleger?",
      very_likely: "Meget sandsynligt",
      very_unlikely: "Meget usandsynligt",
      help_us_improve: "Hvordan kan vi forbedre clockin for dig?",
      what_do_you_agree_with: "Hvilke udsagn er du enig i?",
      choose_three_statements: "Vælg op til tre udsagn.",
      hard_to_use: "svær at betjene",
      lacking_features: "For få funktioner",
      does_not_help_me: "gør ikke min arbejdsdag lettere",
      confusing: "forvirrende",
      poorly_implemented: "Funktioner dårligt implementeret",
      too_buggy: "for fejlbehæftet",
      too_slow: "lange indlæsningstider",
      what_else: "Er der andet, du gerne vil fortælle os?",
      can_we_ask_you_a_few_questions: "Må vi stille dig et par spørgsmål mere?",
      how_happy_are_you_with_the_introduction_of_clockin: "Hvor tilfreds er du med indførelsen af clockin i din virksomhed?",
      how_much_do_you_enjoy_using_clockin: "Hvad synes du om at bruge clockin?",
      how_much_easier_does_clockin_make_your_work: "Hvor meget gør clockin dit daglige arbejde lettere?",
      how_happy_are_you_with_the_following_aspects: "Hvor tilfreds er du med følgende punkter?",
      clarity_of_the_app: "Appens overskuelighed",
      simplicity_of_use: "Enkel betjening",
      app_features: "Funktioner i appen",
      feedback_received: "Vi har modtaget din feedback. Tak, fordi du tog dig tid til det.",
      thanks_for_taking_the_time: "Tak, fordi du tog dig tid til det.",
      what_can_we_do_to_improve: "Kan du fortælle os mere om din oplevelse, så vi kan gøre det endnu bedre næste gang?",
      what_can_we_do_to_get_it_right: "Kan du fortælle os mere om din oplevelse, så vi kan gøre det rigtigt næste gang?",
      comment_placeholder: "Din besked"
    }
  },
  travel_logs: {
    add: "Tilføj rejsedetaljer",
    edit: "Rediger rejsedetaljer",
    saving: "Detaljer om rejsen gemmes...",
    saved_successfully: "Rejseoplysningerne er blevet gemt!",
    unable_to_save: "Desværre gik det ikke 😢."
  },
  attach_file: "Vedhæft fil",
  image_to_text: {
    info: "Sørg for, at teksten er tydeligt genkendelig og kan ses i sin helhed på billedet.",
    attach_image: "Vedhæft billede",
    processing: "Din tekst vil blive læst ind.",
    processing_failed: "Desværre virkede importen ikke 😢.",
    no_text_found: "Ingen tekst kunne genkendes."
  },
  correction_enter_reason: "Angiv venligst en årsag til rettelsen.",
  daily_notes: {
    add: "Skriv en note",
    edit: "Rediger note",
    saving: "Notatet er gemt.",
    saved_successfully: "Note gemt med succes!",
    unable_to_save: "Desværre gik det ikke 😢.",
    no_notes_yet: "Ingen note oprettet",
    create_note: "Opret"
  },
  calendar_sync: {
    title: "Synkroniser tidsplan",
    description: "Synkroniser din arbejdsplan med en kalender, og hold øje med gamle og nye aftaler.",
    url: "Adresse i iCal-format",
    url_description: "Du kan bruge denne adresse til at få adgang til kalenderen fra andre programmer.",
    note: "Bemærk",
    note_description: "Med nogle kalendere kan det tage op til 24 timer, før nye aftaler vises der.",
    sync_now: "Synkroniser kalenderen",
    copied: "Kalender url kopieret."
  },
  registration: {
    skip_all: "Spring alle over",
    already_signed_up: "Jeg har allerede en konto",
    title_1: "Lad os komme i gang! Hvilke tidspunkter vil du gerne optage med clockin?",
    description_1: "Lad os skræddersy clockin til dig",
    option_1_a: "Generel arbejdstid (komme, gå og pause)",
    option_1_b: "Projektets arbejdstid",
    title_2: "Vil du gerne dokumentere?",
    description_2: "Hvilke krav skal opfyldes for dette?",
    option_2_a: 'Fotos',
    option_2_b: "Skitser",
    option_2_c: "Bemærk funktion",
    option_2_d: "Tjeklister og formularer",
    option_2_e: "Digitale projektfiler",
    title_3: "Hvad vil du ellers gerne digitalisere?",
    description_3: "Der er meget mere at opdage på clockin, måske er der noget for dig.",
    option_3_a: "Ferie",
    option_3_b: "Sygdom og fravær",
    option_3_c: "Digital personalemappe",
    option_3_d: "Analyse af virksomheden",
    option_3_e: "Planlægning af implementering",
    option_3_f: "Skattekonsulent for dataoverførsel (DATEV)",
    title_4: "I hvilken branche er din virksomhed aktiv?",
    description_4: "Vi vil gerne lære dig bedre at kende, så vi kan skræddersy clockin mere til dine behov.",
    option_4_a: "tjenester",
    option_4_b: "Håndværk",
    option_4_c: "Sundhed og velvære",
    option_4_d: "Indkøb, bestilling og handel",
    option_4_e: "Hotel og catering",
    option_4_f: "Biler, transport og maskiner",
    option_4_g: "Anden industri",
    title_5: "Hvor mange medarbejdere er der i din virksomhed?",
    description_5: "Med antallet af medarbejdere kan vi tilpasse clockin til din virksomheds størrelse.",
    title_6: "Super! Dit ur er nu sat op",
    description_6: "Vi skal bare bruge dit navn.",
    input_6_a: "Virksomhed",
    input_6_b: "Fornavn",
    input_6_c: "Efternavn",
    input_6_d: 'Telefonnummer',
    title_7: "Du er klar til at gå i gang! Prøv clockin 14 dage gratis!",
    input_7_a: "Din e-mailadresse",
    description_7: "Hvilken e-mailadresse skal vi sende din adgangskode til?",
    input_7_b: "Det var sådan, jeg blev opmærksom på",
    how_did_you_hear_about_clockin: "Hvordan hørte du første gang om clockin?",
    recommendation_option_1: "Anbefaling",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "Søgning på internettet",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Sammenligningsplatform",
    recommendation_option_7: "Artikler i magasiner og på nettet",
    known_from: "Kendt fra",
    agb_1: "Ved at indsende formularen accepterer du ",
    agb_2: 'AGB',
    agb_3: " og den ",
    agb_4: "Politik om beskyttelse af personlige oplysninger",
    start: "Start test",
    validation_failed: "Udfyld venligst alle felter korrekt."
  },
  clocki: {
    listening_heading: "Jeg lytter til dig",
    listening_subtext: "Hvordan kan jeg hjælpe dig?",
    hi_0: "Hej, hvordan kan jeg hjælpe dig?",
    hi_1: "Hej, hvordan kan jeg hjælpe dig?",
    hi_2: "Hej, hvordan kan jeg hjælpe dig?",
    hi_3: "Moin moin, hvad kan jeg gøre for dig?",
    hi_4: "Hej, hvad kan jeg gøre for dig?",
    hi_5: "Hej, hvordan kan jeg hjælpe dig?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "Desværre ser stemmegenkendelse ikke ud til at fungere på din enhed",
    microphone_permission_denied: "Jeg har desværre ikke adgang til din mikrofon. Tjek venligst tilladelserne i indstillingerne, så jeg kan høre dig.",
    please_speak: "Du kan nu tale med Clocki",
    create_activity: "Opret en aktivitet",
    modify_activity: "Skift aktivitet",
    delete_activity: "Slet aktivitet",
    create_daily_note: "Opret en daglig note",
    search_project: "Søg efter et projekt",
    note_copied: "Note kopieret",
    create_absence_request: "Anmod om fravær",
    delete_absence: "Slet fravær",
    confirm_deletion: "Er du sikker på, at din {activity_label} Stempling fra {date} uret skal slettes?",
    confirm_absence_deletion: "Er du sikker på, at din anmodning om {category} fra {startDate} indtil {endDate} Vil du slette?",
    task_before_modification: "Før: {task}",
    starts_at_before_modification: "Starttidspunkt før: {startsAt}",
    ends_at_before_modification: "Sluttidspunkt før: {endsAt}",
    something_went_wrong: "Åh, der gik noget galt, prøv venligst igen senere.",
    was_this_helpful: "Kan Clocki hjælpe dig?",
    actions: {
      CREATE_ABSENCE: {
        title: "Bekræft fravær"
      },
      CREATE_DAILY_NOTE: {
        title: "Opret en note nu",
        daily_notes_disabled: "Desværre er notefunktionen deaktiveret. Bed venligst din administrator om at aktivere funktionen i kontorcentret.",
        success: "Note gemt i den daglige log 🎉."
      },
      CREATE_PROJECT_NOTE: {
        title: "Opret dokumentation nu",
        created_by_clocki: "Oprettet med Clocki"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "Åbn \"Mine tider\" nu"
      },
      REDIRECT_TO_MY_AREA: {
        title: "Åbn \"Mit område\" nu"
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Åbn \"Skift adgangskode\" nu"
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Stempel \"arbejdstid\" nu",
        PAUSE: "Stamp \"Pause\" nu",
        DRIVING_TIME: "Stempel \"rejsetid\" nu",
        LOGOUT: "Lås op nu"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "Kan du lide at bruge Clockin?"
  },
  translation_failed: "Desværre virkede 😕 oversættelsen ikke",
  video_transcript_not_available: "Ingen udskrift tilgængelig",
  video_upload_succeeded: "Videoupload fuldført.",
  video_upload_failed: "Video-upload mislykkedes.",
  video_send_failed: "Videoen kunne ikke sendes i øjeblikket. Vi prøver igen senere.",
  uploading_video: "Uploader video...",
  language_selection_header: "Vælg sprog",
  language_selection_message: "Vælg dit foretrukne sprog",
  shifts: {
    my_shifts: "Mine vagter",
    free_shifts: "Frie vagter",
    next_shift: "Din næste vagt",
    shift_not_found: "Ingen lag fundet",
    show_shift_plan: "Se denne vagtplan",
    no_shift_place: "Ingen placering angivet",
    no_shifts_assigned: "Du er i øjeblikket ikke tildelt nogen vagt",
    free_shifts_unavailable: "Frie vagter er i øjeblikket ikke tilgængelige",
    filter_shift_plans: "Filterskifteplaner",
    no_shift_plans_available: "Ingen vagtplaner tilgængelige",
    filter_locations: "Filtersteder",
    no_locations_available: "Ingen ledige pladser",
    no_plan_selected: "Ingen vagtplan valgt",
    no_shifts_for_plan: "Der findes ingen lag til denne plan",
    no_shifts_for_location: "Der findes ingen vagter for det valgte sted",
    unknown_shift_plan: "Ukendt vagtplan",
    unknown_location: "Ukendt placering",
    loading_more_shifts: "Indlæs flere lag..."
  },
  clockin_reminder_title: "Allerede på arbejde? 🔔",
  clockin_reminder: "Husk at stemple ind.",
  clockout_reminder_title: "Er du allerede ved dagens ende? 🔔",
  clockout_reminder: "Glem ikke at stemple ud.",
  choose_clockin_reminder_time: "Klokke-ind påmindelsestid",
  choose_clockout_reminder_time: "Klokke-ud-påmindelsestid",
  choose_break_reminder_time: "Pauselængde",
  saved_successfully: "Reddet 👍 med succes",
  clock_reminder_channel_name: "Frimærkepåmindelser",
  clock_reminder_channel_description: "Påmindelser om at stemple ind og ud",
  break_reminder_title: "Holder du stadig pause? ⏰",
  break_reminder: "Bemærk: Din pause løber stadig.",
  // Video component translations
  video_not_supported: "Din enhed understøtter ikke videoen :/",
  video_loading_error: "Fejlindlæsning af video",
  video_retry: "Genindlæsning"
};